import { Course } from '../../domain/entities/Course';
import { CourseDTO } from '../dto/CourseDTO';

/**
 * Course Mapper
 * Converts between Course entity and CourseDTO
 */
export class CourseMapper {
  static toDTO(course: Course): CourseDTO {
    return {
      id: course.id,
      slug: course.slug,
      title: course.title,
      progress: course.progress,
      instructor: course.instructor,
      nextClass: course.nextClass,
      color: course.color,
      isDraft: course.isDraft,
    };
  }

  static toDomain(dto: CourseDTO): Course {
    return new Course({
      id: dto.id,
      slug: dto.slug,
      title: dto.title,
      progress: dto.progress,
      instructor: dto.instructor,
      nextClass: dto.nextClass,
      color: dto.color,
      isDraft: dto.isDraft,
    });
  }

  static toDTOList(courses: Course[]): CourseDTO[] {
    return courses.map((course) => this.toDTO(course));
  }

  static toDomainList(dtos: CourseDTO[]): Course[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}
